import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';

@Injectable()
export class RoutingHistoryService {
  private archive: string[] = [];
  private _isFirstPage: boolean = true;

  constructor(
    private router: Router
  ) {
    this.setSubscribtions();
  }

  private setSubscribtions(): void {
    this.router.events.forEach((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.archive.push(event.urlAfterRedirects);
      }
    });
  }

  public get history(): string[] {
    return this.archive ? this.archive : null;
  }

  public get previousUrl(): string {
    return this.archive && this.archive[this.archive.length - 1] ? this.archive[this.archive.length - 1] : '';
  }

  public get isFirstPage(): boolean {
    if (this._isFirstPage && this.archive && this.archive.length >= 1) {
      this._isFirstPage = false;
    }
    return this._isFirstPage;
  }
}
